module.exports = __webpack_public_path__ + "assets/img/hjindxbj.b81ad04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hjindxbj.png
// module id = 4+IP
// module chunks = 1